import { styled } from "goober";
import { PressButton } from "./PressButton";

export const Stepper = styled("div")`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const StepButton = styled(PressButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--alpha4);
  color: var(--text-secondary);

  &:hover {
    background: var(--alpha8);
  }
  &:disabled:hover {
    background: var(--alpha4);
  }
`;
